import { HTTPClientInterface, HTTPRequest } from '@shared/core/HTTPClientInterface';
import { buildURL, SystemURL } from './URLCatalog';
import { ShiftRecipe, ShiftRecipeWithUserIDs } from '@models/QontactPoint';

export class ShiftsService {
	private httpClient: HTTPClientInterface;

	constructor(httpClient: HTTPClientInterface) {
		this.httpClient = httpClient;
	}

	async getShiftRecipe(orgId: string, recipeId: string): Promise<ShiftRecipe> {
		const request = new HTTPRequest();
		request.url = buildURL(SystemURL.Shifts.getRecipe, { org_id: orgId, recipe_id: recipeId });
		request.method = 'GET';
        const response = await this.httpClient.execute(request);
        return response.result;
	}

	async getShiftRecipesForFunctionalUnit(orgId: string, fuID: string): Promise<ShiftRecipeWithUserIDs[]> {
		const request = new HTTPRequest();
		request.url = buildURL(SystemURL.Shifts.getRecipesForFunctionalUnit, 
			{ org_id: orgId, functional_unit_id: fuID }
		);
		request.method = 'GET';
		const response = await this.httpClient.execute(request);
		return response.result;
	}

	async createShiftRecipe(orgId: string, recipeData: any): Promise<any> {
		const request = new HTTPRequest();
		request.url = buildURL(SystemURL.Shifts.postCreateRecipe, { org_id: orgId });
		request.method = 'POST';
		request.body = recipeData;
		const response = await this.httpClient.execute(request);
		return response.result;
	}

	async updateShiftRecipe(orgId: string, recipeId: string, recipeData: ShiftRecipeWithUserIDs): Promise<any> {
		const request = new HTTPRequest();
		request.url = buildURL(SystemURL.Shifts.postUpdateRecipe, { org_id: orgId, recipe_id: recipeId });
		request.method = 'POST';
		request.body = recipeData;
		return this.httpClient.execute(request);
	}

	async deleteShiftRecipe(orgId: string, recipeId: string, qontactPointID: string): Promise<any> {
		const request = new HTTPRequest();
		request.url = buildURL(SystemURL.Shifts.deleteRecipe, 
			{ org_id: orgId, recipe_id: recipeId }
		);
		request.method = 'DELETE';
		request.body = {
			qontactPointID: qontactPointID
		}
		return this.httpClient.execute(request);
	}

	async updateV1ShiftConfiguration(orgId: string, buildingId: string, body: any): Promise<any> {
		const request = new HTTPRequest();
		request.url = buildURL(SystemURL.Shifts.postV1ConfigUpdate, {
			org_id: orgId,
			building_id: buildingId,
		});
		request.method = 'POST';
		request.body = body;
		//El body es demasiado complejo para tiparlo ahora mismo
		return this.httpClient.execute(request);
	}
}
